'use client'

import { useCallback, useState } from 'react'

/**
 * Hook for managing screen reader announcements
 * Implements ARIA live regions for dynamic content updates
 */
export function useScreenReaderAnnouncements() {
  const [announcement, setAnnouncement] = useState('')
  const [politeness, setPoliteness] = useState<'polite' | 'assertive'>('polite')

  const announce = useCallback((message: string, priority: 'polite' | 'assertive' = 'polite') => {
    setPoliteness(priority)
    setAnnouncement('')
    // Small delay to ensure screen readers pick up the change
    setTimeout(() => setAnnouncement(message), 100)
  }, [])

  const clearAnnouncement = useCallback(() => {
    setAnnouncement('')
  }, [])

  return {
    announcement,
    politeness,
    announce,
    clearAnnouncement,
  }
}
